import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import ButtonActionIcon from "./ButtonActionIcon";

const InlineStyleSelector = ({ value, onChange, type }) => {
  //   const { customStyles } = useAppBlocksContext();
  const [selectedHeading, setSelectedHeading] = useState(null);
  const [customStyles, setCustomStyles] = useState({});

  const renderStyles = () => {
    let inlineStyle = {};
    switch (type) {
      case "field":
      case "tabview":
      case "label":
      case "tableview":
      case "section":
        inlineStyle = {
          color: "",
          backgroundColor: ""
        };
        break;

      default:
        return null;
    }
    return { ...inlineStyle, ...value };
  };
  const handleHeadingClick = (styleType) => {
    setSelectedHeading((prevSelected) => (prevSelected === styleType ? null : styleType));
  };

  //   const handleInputChange = (e) => {
  //     const { name, value } = e.target;
  //     const obj = {
  //       ...customStyles,
  //       [name]: value
  //     };
  //     setCustomStyles(obj);
  //     onChange(obj);
  //   };
  const handleColorPicker = (name, value) => {
    const obj = {
      ...customStyles,
      [name]: value
    };
    setCustomStyles(obj);
    onChange(obj);
  };
  const handleResetColor = () => {
    let resetVal = JSON.parse(JSON.stringify(value));
    resetVal = { ...resetVal, [selectedHeading]: "" };
    onChange(resetVal);
  };
  const renderInputByHeading = (styleType) => {
    switch (styleType) {
      case "color":
      case "backgroundColor":
        return (
          <div>
            {value[selectedHeading] && (
              <div className="field_color_config_container" style={{ marginTop: "-4px" }}>
                <div className="field_color_container">
                  <div style={{ backgroundColor: value[selectedHeading] }}></div>
                </div>
                <ButtonActionIcon type="delete" size="xsm" onClick={handleResetColor} />
              </div>
            )}
            <SketchPicker
              name={styleType}
              color={value[selectedHeading]}
              onChange={(e) => handleColorPicker(styleType, e.hex)}
            />
          </div>
        );

      default:
        return null;
    }
  };
  useEffect(() => {
    setCustomStyles(renderStyles());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return (
    <div>
      <div className={`assigned_style_sample`} style={value}>
        Inline Sample
      </div>
      <label className="builder_label">Inline Style</label>
      <div className="class_btn_container button">
        {Object.keys(customStyles).map((styleType) => (
          <div key={styleType}>
            <button
              style={{
                backgroundColor: value[styleType] !== undefined && value[styleType] !== "" ? "#667085" : "",
                color: value[styleType] !== undefined && value[styleType] !== "" ? "#fff" : ""
              }}
              className={`custom_styles ${selectedHeading === styleType ? "selected_style_btn" : ""}`}
              onClick={() => handleHeadingClick(styleType)}
            >
              {styleType}
            </button>
          </div>
        ))}
      </div>
      {Object.keys(customStyles).map((styleType) => (
        <div key={styleType}>{selectedHeading === styleType && renderInputByHeading(styleType)}</div>
      ))}
    </div>
  );
};

export default InlineStyleSelector;
